<template>
  <el-tag
    v-if="label"
    :type="tagType"
    :effect="effect"
    :size="size"
    :hit="hit"
    :color="color"
  >
    {{ label }}
  </el-tag>
  <span v-else>{{ value }}</span>
</template>

<script>
import { computed } from 'vue'
import { getDictLabel } from '@/utils/dict'

export default {
  name: 'DictTag',
  props: {
    // 字典类型
    dictCode: {
      type: String,
      required: true
    },
    // 对应值
    value: {
      type: [String, Number],
      required: true
    },
    // 显示英文
    useEnName: {
      type: Boolean,
      default: false
    },
    // 标签类型
    type: {
      type: String,
      default: ''
    },
    // 主题
    effect: {
      type: String,
      default: 'light'
    },
    // 尺寸
    size: {
      type: String,
      default: 'default'
    },
    // 是否有边框描边
    hit: {
      type: Boolean,
      default: false
    },
    // 颜色
    color: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    // 标签文本
    const label = computed(() => {
      return getDictLabel(props.dictCode, props.value, props.useEnName)
    })
    
    // 根据值设置不同类型的标签样式
    const tagType = computed(() => {
      if (props.type) {
        return props.type
      }
      
      // 可根据字典类型和值自定义标签类型
      if (props.dictCode === 'sys_status') {
        return props.value === '1' ? 'success' : 'danger'
      }
      
      return ''
    })
    
    return {
      label,
      tagType
    }
  }
}
</script>